import { SET_IS_FORM_SENDING, SET_IS_CUSTOM_UID_LOADING, SET_CUSTOM_UID } from './actions';

export const initialState = {
	customUid: null,
	isCustomUidLoading: false,
	isFormSending: false,
};

const customUidModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_CUSTOM_UID:
			return {
				...state,
				customUid: payload,
			};
		case SET_IS_CUSTOM_UID_LOADING:
			return {
				...state,
				isCustomUidLoading: payload,
			};

		case SET_IS_FORM_SENDING:
			return {
				...state,
				isFormSending: payload,
			};
		default:
			return state;
	}
};

export default customUidModalReducer;
